// extracted by mini-css-extract-plugin
export default {"background_super_proxy":"proxyLoading_background_super_proxy__pnr50"};